import FingerprintJS from '@fingerprintjs/fingerprintjs';

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

/**
 * Resolve the FingerprintJS visitor identifier for the current browser.
 * @returns The stable visitor id, or null when unavailable.
 */
export async function getFingerprintVisitorId(): Promise<string | null> {
  // Get the visitor identifier when you need it.
  const fp = await fpPromise;
  const result = await fp.get();
  return result?.visitorId || null;
}
